import { AlertDiamondIcon } from 'hugeicons-react';
import React, { useState,useRef, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../api';
import { PrimaryButton, SecondaryButton } from '../forms/buttons';
import Cookies from 'js-cookie';

const DeleteTargetPopup = ({ targetId, targetName, onClose, onDelete }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                onClose(); 
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const handleSubmit = async (event) => {
        event.preventDefault();  
        setIsSubmitting(true);
        try {
            const token = Cookies.get('accessToken');
            const response = await axios({
                method: 'delete',
url: `${API_URL}/targets/delete_target/${targetId}/`, 
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
    
            if (response.status === 200) {
                onDelete(targetId); 
            } else {
                console.error('Failed to delete target, status code:', response.status);
            }
        } catch (error) {
            console.error('Error deleting target:', error);
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <div className='popup-overlay'>
           <form className='delete-target-popup add-target-popup' onSubmit={handleSubmit} ref={popupRef}>
            <div className='delete-title'>
                <AlertDiamondIcon size={48} color="#FF0000" />
                <div className='delete-confirmation'>
                    <h4 className='title'>Delete Target</h4>
                    <p className='paragraph-red'>Do you really want to delete the target called <b>{targetName}</b>?</p>
                </div>
            </div>


                <div className='buttons'>
                    <SecondaryButton onClick={onClose} buttonText={'Cancel'} />
                    <PrimaryButton isLoading={isSubmitting} buttonText={'Delete'} />
                </div>
            </form>
        </div>
    );
};

export default DeleteTargetPopup;